import map from 'lodash/map';
import { breadcrumbsRetrievedType } from './BreadcrumbsConstants';
import {
  retrieveBreadcrumbs as retrieveBreadcrumbsHelper,
  goToResultPage as goToResultPageHelper,
  backToQueryHandler as backToQueryHandlerHelper,
  createAlert as createAlertHelper,
  updateBreadcrumbData as updateBreadcrumbDataHelper,
  openBatchExecutionDetails as openBatchExecutionDetailsHelper,
  showStructurePopup as showStructurePopupHelper,
} from './BreadcrumbsHelper';

export function retrieveBreadcrumbs(databaseId) {
  return async (dispatch) => {
    const breadcrumbs = await retrieveBreadcrumbsHelper(databaseId);
    const breadcrumbsWithComments = await Promise.all(
      map(breadcrumbs, (breadcrumb) => (breadcrumb.comment ? breadcrumb : updateBreadcrumbDataHelper(breadcrumb)))
    );

    dispatch({
      type: breadcrumbsRetrievedType,
      breadcrumbs: breadcrumbsWithComments,
    });

    return breadcrumbs;
  };
}

export function goToResultPage(crumb) {
  return () => goToResultPageHelper(crumb);
}

export function backToQueryHandler(breadcrumb, action) {
  return () => backToQueryHandlerHelper(breadcrumb, action);
}

export function createAlert(breadcrumb) {
  return () => createAlertHelper(breadcrumb);
}

export function openBatchExecutionDetails(breadcrumb) {
  return () => openBatchExecutionDetailsHelper(breadcrumb);
}

export function showStructurePopup(structure) {
  return () => showStructurePopupHelper(structure);
}
